import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { SolicitacaoHonra, SolicitacaoHonraExportacao } from 'src/app/model/solicitacao-honra.model';

@Injectable({
  providedIn: 'root'
})
export class SolicitacaoHonraService extends FgiBackEndService<SolicitacaoHonra> {

  // @Override
  getNewEntity() {
    const novo = new SolicitacaoHonra();
    novo.dataEnvio = new Date();
    return novo;
  }

  // @Override
  protected getResourceURL(): string {
    return 'front/solicitacoes-honra';
  }

  getSolicitacoesExportacao(params?: any): Observable<Array<SolicitacaoHonraExportacao>> {
    return this.http.get(`${this.BASE_URL}/exportar`, {params: params}).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<SolicitacaoHonraExportacao>>;
  }

  // nao tem no BaseEntityService pra fazer override
  getSolicitacaoHonra(id): Observable<SolicitacaoHonra> {
    return this.http.get(`${this.BASE_URL}/${id}`).pipe(
      catchError((e) => this.handleError(e))) as Observable<SolicitacaoHonra>;
  }

  // nao tem no BaseEntityService pra fazer override
  getSolicitacoesHonra(params?: any): any {
    return this.http.get(`${this.BASE_URL}`, {params: params}).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<SolicitacaoHonra>>;
  }

  getOperacaoSolicitacaoHonra(idOperacao: number): any{
    return this.http.get(`rest/front/operacoes/${idOperacao}`).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<SolicitacaoHonra>>;
  }

  getSolicitacoesHonraOperacao(idOperacao: number): any {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/operacao/${idOperacao}`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<SolicitacaoHonra>>;
  }

  // nao tem no BaseEntityService pra fazer override
  getSolicitacoesHonraPorProtocoloNegocio(idNegocio: string, params?: any): any {
    const options: any = blockUi();
    options.params = params;
    return this.http.get(`${this.BASE_URL}/protocoloNegocio/${idNegocio}`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<SolicitacaoHonra>>;
  }

  reprovar (id: number, motivo: string): Observable<SolicitacaoHonra> {
    return this.http.post(`${this.BASE_URL}/${id}/reprovar?motivo=`+motivo, {}).pipe(
      catchError((e) => this.handleError(e))) as Observable<SolicitacaoHonra>;
  }
}
